var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftDarkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90001 20.9667L0.633343 11.7C0.522232 11.5889 0.444455 11.4778 0.40001 11.3667C0.355566 11.2556 0.333344 11.1333 0.333344 11C0.333344 10.8667 0.355566 10.7444 0.40001 10.6333C0.444455 10.5222 0.522232 10.4111 0.633343 10.3L9.93334 1C10.1111 0.822226 10.3333 0.733337 10.6 0.733337C10.8667 0.733337 11.1 0.833337 11.3 1.03334C11.5 1.23334 11.6 1.46667 11.6 1.73334C11.6 2 11.5 2.23334 11.3 2.43334L3.73334 10H20.2667C20.5556 10 20.7945 10.0944 20.9833 10.2833C21.1722 10.4722 21.2667 10.7111 21.2667 11C21.2667 11.2889 21.1722 11.5278 20.9833 11.7167C20.7945 11.9056 20.5556 12 20.2667 12H3.73334L11.3333 19.6C11.5111 19.7778 11.6 20 11.6 20.2667C11.6 20.5333 11.5 20.7667 11.3 20.9667C11.1 21.1667 10.8667 21.2667 10.6 21.2667C10.3333 21.2667 10.1 21.1667 9.90001 20.9667Z",
    fill: "#1D8158"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftDarkGreen);
export default __webpack_public_path__ + "static/media/arrow-left-dark-green.8c752a2bd7eb5c54a773f17dda62f9f1.svg";
export { ForwardRef as ReactComponent };